import { setTxpSettingsErrorDialogViewState } from '../actions/txpSettingsDialogActions';
import { mutator } from 'satcheljs';
import getStore from '../store/store';

export const setTxpSettingsErrorDialogViewStateMutator = mutator(
    setTxpSettingsErrorDialogViewState,
    actionMessage => {
        getStore().txpSettingsErrorDialogViewState =
            actionMessage.txpSettingsErrorDialogViewStateToSet;
    }
);
